import { useState } from 'react';
/**
 * Wraps a `onRefresh(id)` callback with a spinner boolean so the summary
 * card can render the spinning refresh icon without each panel reinventing
 * the try/finally dance.
 */
export function useRefreshState(onRefresh) {
    const [refreshing, setRefreshing] = useState(false);
    const trigger = onRefresh
        ? async (id) => {
            setRefreshing(true);
            try {
                await onRefresh(id);
            }
            finally {
                setRefreshing(false);
            }
        }
        : undefined;
    return { refreshing, trigger };
}
//# sourceMappingURL=use-refresh-state.js.map